import { useEffect } from 'react';

interface UseCopyDatabaseContentProps {
  onCopy: () => void;
  isDisabled?: boolean;
}

/**
 * Registers a document event listener that reacts to copy events.
 * This is used to copy the selected database content to the clipboard.
 */
export const useCopyListener = ({ isDisabled, onCopy }: UseCopyDatabaseContentProps) => {
  useEffect(() => {
    const copyListener = (e: ClipboardEvent) => {
      if (getSelection()?.type !== 'Range') {
        e.preventDefault();
        onCopy();
      }
    };

    if (isDisabled) {
      return;
    }
    document.addEventListener('copy', copyListener);
    return () => {
      document.removeEventListener('copy', copyListener);
    };
  }, [isDisabled, onCopy]);
};
